// List of sentences to display as typewriter text
let _CONTENT = ["Condoms", "Playthings", "Lubes", "Real Feel Playkit"];
let _PART = 0;
let _PART_INDEX = 0;
let _INTERVAL_VAL;

//Function which is used to retrieve the typewriter text and implement delete and type effects on the text
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth < 767) return; 
  let _ELEMENT = document.querySelector("#text");
  let _SEARCHELEMENT = document.querySelector('#searchtext');

  if (!_ELEMENT && !_SEARCHELEMENT) return;

  _INTERVAL_VAL = setInterval(Type, 50);

  // Implements deleting effect
  function Delete() {
    let text = _CONTENT[_PART].substring(0, _PART_INDEX - 1);
    if (_ELEMENT) _ELEMENT.innerHTML = text;
    if (_SEARCHELEMENT) _SEARCHELEMENT.innerHTML = text;
    _PART_INDEX--;
    if (text === "") {
      clearInterval(_INTERVAL_VAL);
      if (_PART == _CONTENT.length - 1) _PART = 0;
      else _PART++;
      _PART_INDEX = 0;
      setTimeout(function () {
        _INTERVAL_VAL = setInterval(Type, 100);
      }, 200);
    }
  }

  // Implements typing effect
  function Type() {
    let text = _CONTENT[_PART].substring(0, _PART_INDEX + 1);
    document.querySelectorAll(".pre_txt").forEach(function (preTxt) {
      preTxt.innerHTML = "Search For ";
    });
    if (_ELEMENT) _ELEMENT.innerHTML = text;
    if (_SEARCHELEMENT) _SEARCHELEMENT.innerHTML = text;
    _PART_INDEX++;
    if (text === _CONTENT[_PART]) {
      clearInterval(_INTERVAL_VAL);
      setTimeout(function () {
        _INTERVAL_VAL = setInterval(Delete, 50);
      }, 1000);
    }
  }
});

//Function adds a active state for the megamenu items  
function ActiveMegaMenuItem(title){
  document.querySelectorAll(`[data-menu-title='${title}']`).forEach((div)=>{
    div.classList.add("is-active")
  })
}

//Function removes a active state for the megamenu items  
function InactiveMegaMenuItem(title){
  document.querySelectorAll(`[data-menu-title='${title}']`).forEach((div)=>{
      div.classList.remove("is-active")
  })
}

//Event listener to show the mobile nav bar on scroll down and hide it on scroll up
let lastScrollTop = 0;

window.addEventListener("scroll", function() {
  const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (currentScrollTop > lastScrollTop) {
    document.querySelector('.mob__nav__container')?.classList.remove('animate');
    document.querySelector('.filters__sortby__container')?.classList.remove('animate');
    document.querySelector('.collection__subcategories__container')?.classList.remove('animate');
    document.querySelector('.mobile__sub__categories__container')?.classList.remove('animate');
    document.querySelector('.accordion-banner')?.classList.remove('animate');
  } else {
    document.querySelector('.mob__nav__container')?.classList.add('animate');
    document.querySelector('.filters__sortby__container')?.classList.add('animate');
    document.querySelector('.collection__subcategories__container')?.classList.add('animate');
    document.querySelector('.mobile__sub__categories__container')?.classList.add('animate');
    document.querySelector('.accordion-banner')?.classList.add('animate');
  }

  lastScrollTop = currentScrollTop;
});

//Event listeners for search bar and typewriter visibility
document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.querySelector(".main__search__input");
  const typewriterDropdown = document.getElementById("typewriter__dropdown");
  const productContainer = document.querySelector('.inital__product__container');

  // To initially check if there is already text present in the search input field, and hide the search typewriter if there is any text present
  if (typewriterDropdown) {
    typewriterDropdown.style.visibility = (searchInput?.value && searchInput.value.trim().length > 0) ? "hidden" : "visible";

    searchInput?.addEventListener("input", function () {
      typewriterDropdown.style.visibility = (searchInput.value && searchInput.value.trim().length > 0) ? "hidden" : "visible";
    });
  }

  if (searchInput && productContainer) {
    searchInput.addEventListener('input', function() {
      if (this.value.trim() === '') {
        productContainer.style.display = 'grid';
      } else {
        productContainer.style.display = 'none';
      }
    });
  }

  // Get the height of the search__field container
  const searchField = document.querySelector('.search__field');
  if (searchField) {
    const searchFieldHeight = window.getComputedStyle(searchField)?.height;
    if (searchFieldHeight) {
      document.documentElement.style.setProperty('--search-field-height', searchFieldHeight);
    }
  }
});